export default __webpack_public_path__ + "static/media/image-best-gear.4d4a28e9.jpg";